import { render } from "./5m.vue?vue&type=template&id=6ac0f684&scoped=true"
import script from "./5m.vue?vue&type=script&lang=js"
export * from "./5m.vue?vue&type=script&lang=js"

import "./5m.vue?vue&type=style&index=0&id=6ac0f684&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac0f684"]])

export default __exports__